import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import CloseButton from '../../elements/CloseButton';
import SaveButton from '../../elements/SaveButton';
const styles = css `
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 0.55px solid rgb(240, 240, 240);

  button {
    background-color: transparent;
    border: none;
    padding: 5px;
  }
  button:disabled {
    opacity: 0.6;
  }
`;
function PreferencesHeader({ onClose, onSave }) {
    return (_jsxs("div", { css: styles, children: [_jsx(CloseButton, { onClick: onClose, popupTitle: "close Preferences" }), _jsx(SaveButton, { onClick: onSave, popupTitle: "save Preferences" })] }));
}
export default memo(PreferencesHeader);
